module.exports = __webpack_public_path__ + "credit_card.ab14cfd1aabdd9b764894657aef11149.svg";